/* ✅ CONFIG */
const WISHLIST_KEY = "wishlist";

/* ✅ Get wishlist array */
function getWishlistData() {
  try {
    const data = JSON.parse(localStorage.getItem(WISHLIST_KEY));
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
}

/* ✅ Save wishlist array */
function setWishlistData(data) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(data));
}

/* ✅ Check if product already wishlisted */
function isWishlisted(handle) {
  const wishlist = getWishlistData();
  return wishlist.some((item) => item.handle === handle);
}

/* ✅ Update wishlist count in header */
function updateWishlistCount() {
  const wishlistData = getWishlistData();
  const count = wishlistData.length;

  document.querySelectorAll("[data-wishlist-count]").forEach((badge) => {
    badge.textContent = count;
    badge.hidden = count === 0;
  });
}

/* ✅ Update wishlist buttons active state */
function updateWishlistButtons() {
  const wishlist = getWishlistData();
  const handles = wishlist.map((p) => p.handle);

  document.querySelectorAll("[data-wishlist-add]").forEach((btn) => {
    const json = btn.getAttribute("data-product");
    if (!json) return;

    let product = null;
    try {
      product = JSON.parse(json);
    } catch (e) {
      console.error("Wishlist: Invalid JSON in data-product", e);
      return;
    }

    const active = handles.includes(product.handle);

    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");

    // Update SVG heart icon color
    const svg = btn.querySelector(".icon-wish");
    if (svg) {
      const paths = svg.querySelectorAll("path");
      if (active) {
        // Red color when wishlisted
        svg.style.color = "#EF4444";
        paths.forEach((path) => {
          if (path.hasAttribute("opacity")) {
            path.style.fill = "#EF4444";
          }
        });
      } else {
        // Gray color when not wishlisted
        svg.style.color = "#9CA3AF";
        paths.forEach((path) => {
          if (path.hasAttribute("opacity")) {
            path.style.fill = "#9CA3AF";
            path.style.opacity = "0.2";
          } else {
            path.style.fill = "currentColor";
          }
        });
      }
    }
  });
}

/* ✅ Toggle wishlist */
function toggleWishlist(productData) {
  if (!productData || !productData.handle) return;

  let wishlist = getWishlistData();
  const exists = wishlist.find((item) => item.handle === productData.handle);

  if (exists) {
    wishlist = wishlist.filter((item) => item.handle !== productData.handle);
  } else {
    wishlist.push(productData);
  }

  setWishlistData(wishlist);
  updateWishlistCount();
  updateWishlistButtons();

  // Re-render wishlist page if open
  renderWishlistPage();
}

/* ✅ Remove single item from wishlist */
function removeWishlistItem(handle) {
  let wishlist = getWishlistData();
  wishlist = wishlist.filter((item) => item.handle !== handle);

  setWishlistData(wishlist);
  updateWishlistCount();
  updateWishlistButtons();
  renderWishlistPage();
}

/* ✅ Clear wishlist */
function clearWishlist() {
  setWishlistData([]);
  updateWishlistCount();
  updateWishlistButtons();
  renderWishlistPage();
}

/* ✅ Render Wishlist Page */
function renderWishlistPage() {
  const grid = document.querySelector("[data-wishlist-grid]");
  if (!grid) return;

  const wishlist = getWishlistData();

  if (!wishlist.length) {
    grid.innerHTML = `<p style="margin: 0;">Your wishlist is empty.</p>`;
    return;
  }

  // Set grid to 4 columns
  grid.style.display = "grid";
  grid.style.gridTemplateColumns = "repeat(auto-fill, minmax(24%, 1fr))";
  grid.style.gap = "1.5rem";

  grid.innerHTML = wishlist
    .map((p) => {
      return `
      <div class="wishlist-card" style="border:1px solid #e5e5e5;padding:14px;border-radius:10px;display:flex;flex-direction:column;">
        <a href="${p.url}" style="text-decoration:none;flex-grow:1;">
          <img src="${p.image}" alt="${p.title}" style="width:100%;height:auto;border-radius:10px;" />
        </a>

        <div style="margin-top:10px;flex-grow:1;display:flex;flex-direction:column;">
          <h3 style="margin:0;font-size:16px;">${p.title}</h3>
          ${p.vendor ? `<p style="margin:6px 0;color:#666;font-size:14px;">${p.vendor}</p>` : ""}
          ${p.price ? `<p style="margin:6px 0;flex-grow:1;"><strong>${p.price}</strong></p>` : ""}

          <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px;">
            <button
              type="button"
              data-wishlist-remove
              data-handle="${p.handle}"
              class="button button--primary button--secondary"
              style="flex:1;min-height:auto;"
            >
              Remove
            </button>
          </div>
        </div>
      </div>`;
    })
    .join("");
}

/* ✅ Event Delegation (no inline onclick) */
document.addEventListener("click", (e) => {
  /* Add / Toggle wishlist */
  const addBtn = e.target.closest("[data-wishlist-add]");
  if (addBtn) {
    const json = addBtn.getAttribute("data-product");
    if (!json) return;

    try {
      const productData = JSON.parse(json);
      toggleWishlist(productData);
    } catch (err) {
      console.error("Wishlist: JSON parse error", err);
    }
    return;
  }

  /* Remove wishlist item (wishlist page) */
  const removeBtn = e.target.closest("[data-wishlist-remove]");
  if (removeBtn) {
    const handle = removeBtn.getAttribute("data-handle");
    removeWishlistItem(handle);
    return;
  }

  /* Clear wishlist */
  const clearBtn = e.target.closest("[data-wishlist-clear]");
  if (clearBtn) {
    clearWishlist();
    return;
  }
});

/* ✅ Init */
document.addEventListener("DOMContentLoaded", () => {
  updateWishlistCount();
  updateWishlistButtons();
  renderWishlistPage();
});

/* ✅ Optional global exports (debug/testing) */
window.toggleWishlist = toggleWishlist;
window.getWishlistData = getWishlistData;
window.setWishlistData = setWishlistData;
